import { render, staticRenderFns } from "./service_payment.vue?vue&type=template&id=50da7282&scoped=true"
import script from "./service_payment.vue?vue&type=script&lang=js"
export * from "./service_payment.vue?vue&type=script&lang=js"
import style0 from "./service_payment.vue?vue&type=style&index=0&id=50da7282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da7282",
  null
  
)

export default component.exports